var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user_descriptions" }, [
    _c(
      "div",
      { staticClass: "user_descr" },
      [
        _c("info_field", {
          attrs: {
            is_disabled: this.is_disabled,
            f_uniq: "ctgk",
            f_type: "google_key",
            f_title: _vm.__t("GOOGLE_KEY"),
            f_val: _vm.pwa.google_key,
          },
          on: { update_categ: _vm.change_atr },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }